import CustomMorePopover from '@/components/global/buttons/CustomMorePopover';
import { useTranslate } from 'react-admin';
import CustomEditModalButton from '@/components/global/buttons/CustomEditModalButton.jsx';
import { useDrawer } from '@/composables/useDrawer';
import FilterIcon from '@/assets/icons/filter-icon.svg?react';
import ActivateIcon from '@/assets/icons/activate-icon.svg?react';
import PriorityIcon from '@/assets/icons/priority-icon.svg?react';
import { CustomButton } from '@/components/global/buttons/CustomButton.jsx';

export const PromotionalCampaingsMoreActionsPopover = ({ permissions, record }) => {
    const { openDrawer } = useDrawer();
    const translate = useTranslate();
    if (!record) return null;

    return (
        <CustomMorePopover permissions={permissions} record={record}>
            <CustomButton variant='text' label={translate('resources.campaign.labels.deactivate')} startIcon={<ActivateIcon />} disabled />
            <CustomButton variant='text' label={translate('resources.campaign.labels.changePriority')} startIcon={<PriorityIcon />} disabled />
            <CustomButton variant='text' label={translate('resources.campaign.labels.showRelatedTransactions')} startIcon={<FilterIcon />} disabled />
            <CustomEditModalButton
                onOpen={() => openDrawer(record.id, 'promotional-campaign-edit')}
                label={translate('resources.campaign.labels.editCampaign')}
                disabled={true}
            />
        </CustomMorePopover>
    );
};
